<template>
  <section>
    <div class="mt-4 mb-3">
      <h4>A nombre de quién se crean Trámites de este tipo</h4>
    </div>
    <div>
            <div class="col-12 p-0">
                <p>Selecciona los tipos de personas o iniciadores a nombre de los cuales se pueden iniciar trámites de este tipo.</p>
                <p>Si no especifica alguno, se mostrarán todos los tipos de personas e iniciadores.</p>
            </div>
            <div class="wrapper-content p-0">
                <div class="row">
                <div class="col-6">
                    <div class="row">
                    <div class="col-auto d-flex align-items-end">
                        <LmTreeSelect
                        :disabled="published"
                        class="mr-4"
                        :label="$t('people_types')"
                        clearable
                        pathToGetOptions="/peopletypes/all"
                        v-model="instanceStarters.peopleTypes"
                        />
                        <LmButton
                        :disabled="!instanceStarters.peopleTypes"
                        buttonClass="btn-primary"
                        @click="onAddPrivilege('peopleTypes')"
                        :value="$t('add')"
                        />
                    </div>
                    <div class="col-auto d-flex align-items-end">
                        <LmTreeSelect
                        :disabled="published"
                        class="mr-4"
                        :label="$t('initiator_types')"
                        clearable
                        pathToGetOptions="/initiatortypes/all"
                        v-model="instanceStarters.initiatorTypes"
                        />
                        <LmButton
                        :disabled="!instanceStarters.initiatorTypes"
                        buttonClass="btn-primary"
                        @click="onAddPrivilege('initiatorTypes')"
                        :value="$t('add')"
                        />
                    </div>
                    </div>
                </div>

                <div class="col-6">
                    <b-list-group v-if="privileges.length">
                        <b-list-group-item v-for="(initiator, index) of privileges" :key="index">
                        <div class="d-flex align-items-center">
                            <i
                            style="font-size: 20px"
                            class="mr-2 mdi"
                            :class="`mdi-${initiator.icon}`"
                            />
                            <span class="flex-grow-1">
                            {{ initiator.name }}
                            </span>
                            <i
                            v-if="!published"
                            style="font-size: 20px"
                            class="mr-2 clickable mdi mdi-close"
                            @click="onDeletePrivilege(initiator)"
                            />
                        </div>
                        </b-list-group-item>
                    </b-list-group>
                    <div v-else>
                        <LmSvgIcon
                        icon="LmNoDataIcon"
                        width="7.5em"
                        wrapperClass="mb-4 d-flex justify-content-center"
                        />
                        <p class="text-center">
                        Todavía no se han seleccionado iniciadores para los trámites.
                        </p>
                    </div>
                </div>
                </div>
            </div>
    </div>
  </section>
</template>

<script>
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmSelect from '@/components/form/elements/LmSelect'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmButton from '@/components/form/elements/LmButton'
import LmTagsInput from '@/components/form/elements/LmTagsInput'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmTreeSelect,
    LmButton,
    LmSelect,
    LmCheckbox,
    LmTagsInput
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    published: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      instanceStarters: {
        peopleTypes: null,
        initiatorTypes: null
      }
    }
  },
  computed: {
    privileges () {
      let items = []
      for (const key in this.value) {
        const arr = this.value[key].map(el => {
          return {
            ...el,
            group: key,
            icon: this.setPrivilegeIcon(key)
          }
        })
        items = items.concat(arr)
      }
      return items
    }
  },
  methods: {
    onAddPrivilege (type) {
      if (this.value[type].some(val => val.id === this.instanceStarters[type].id)) {
        this.clearData(type)
        this.lmToastDangerMessage('No se agregaron los tipos de iniciadores duplicados.', 'Iniciador duplicado')
        return
      }
      this.value[type].push(this.instanceStarters[type])
      this.clearData(type)
    },
    clearData (prop) {
      this.instanceStarters[prop] = null
    },
    onDeletePrivilege (initiator) {
      this.value[initiator.group] = this.value[initiator.group].filter(item => item.id !== initiator.id)
    },
    setPrivilegeIcon (type) {
      const icons = {
        initiatorTypes: 'briefcase',
        peopleTypes: 'account-group'
      }
      return icons[type]
    }
  },
  async created () {

  }
}
</script>
